(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["webdev-scroll-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ml-webdev-story')) return;
  const clamp = (n, a = 0, b = 1) => Math.min(b, Math.max(a, n));
  const ease = n => { n = clamp(n); return n * n * (3 - 2 * n); };
  const mix = (a, b, p) => a + (b - a) * p;
  const states = {
    design: [0, 8, -12, -4, .88, 1, 1, 0, 0, 0, 0, 1, 1, 0],
    build: [0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 1, 0],
    optimise: [-5, 6, -12, -3, .82, 0, 0, 1, 0, 0, 0, 1, 1, -12],
    professional: [5, 4, 10, 3, .86, 0, 0, .15, 1, 0, 0, .8, 1, -26],
    custom: [5, 13, -14, 5, .83, 0, .3, 0, 0, 1, 0, .14, 0, -10],
    security: [0, 0, 0, 0, .9, 0, 0, 0, 0, .05, 1, .08, 0, 0]
  };
  const labels = {design:'DESIGN SYSTEM',build:'SHOPIFY / FRONT END',optimise:'RESPONSIVE EXPERIENCE',professional:'DETAIL & CONSISTENCY',custom:'CODE & CONNECTIONS',security:'TEST & REFINE'};
  class WebdevStory extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.frame = 0;
      this.userPaused = false;
      this.chapters = [...this.querySelectorAll('.mlwd-chapter')];
      this.stage = this.querySelector('.mlwd-stage');
      this.art = this.querySelector('.mlwd-art');
      this.device = this.querySelector('.mlwd-device');
      this.capture = this.querySelector('.mlwd-capture');
      this.layers = [...this.querySelectorAll('.mlwd-layer')];
      this.wire = this.querySelector('.mlwd-wireframe');
      this.phone = this.querySelector('.mlwd-phone');
      this.swatch = this.querySelector('.mlwd-swatch');
      this.code = this.querySelector('.mlwd-code');
      this.security = this.querySelector('.mlwd-security');
      this.tags = [...this.querySelectorAll('.mlwd-tag')];
      this.ribbon = this.querySelector('.mlwd-ribbon-track');
      this.toggle = this.querySelector('.mlwd-motion');
      this.number = this.querySelector('.mlwd-stage-number');
      this.status = this.querySelector('.mlwd-stage-status');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.small = matchMedia('(max-width: 700px)');
      this.short = matchMedia('(max-height: 620px)');
      this.requestTick = () => {
        if (!this.frame && this.isConnected && !document.hidden) this.frame = requestAnimationFrame(() => { this.frame = 0; this.paint(); });
      };
      const signal = this.controller.signal;
      this.toggle.hidden = this.dataset.motion !== 'true';
      this.toggle.addEventListener('click', () => { this.userPaused = !this.userPaused; this.configure(); }, {signal});
      window.addEventListener('scroll', this.requestTick, {passive:true,signal});
      window.addEventListener('resize', this.requestTick, {passive:true,signal});
      window.addEventListener('pageshow', this.requestTick, {signal});
      document.addEventListener('visibilitychange', this.requestTick, {signal});
      this.configureBound = () => this.configure();
      for (const mq of [this.motion,this.small,this.short]) mq.addEventListener('change', this.configureBound);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        event.target.scrollIntoView({block:'center',behavior:'auto'});
        this.requestTick();
      }, {signal});
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.requestTick);
        this.observer.observe(this);
        const header = document.querySelector('[data-storefront-header], header-group, .shopify-section-group-header-group, #shopify-section-header, .header-wrapper, header.site-header');
        this.header = header;
        if (header) this.observer.observe(header);
      }
      this.configure();
    }
    configure() {
      this.enabled = this.dataset.motion === 'true' && !this.motion.matches && !this.userPaused && !this.short.matches && this.chapters.length > 0;
      this.classList.toggle('is-motion', this.enabled);
      this.toggle.setAttribute('aria-pressed', String(!this.enabled));
      this.requestTick();
    }
    paint() {
      const own = this.getBoundingClientRect();
      if (own.bottom < 0 || own.top > innerHeight) return;
      // No wheel interception, synthetic scrolling, timers, tracking or network calls.
      let headerHeight = this.small.matches ? 82 : 112;
      if (this.header) {
        const box = this.header.getBoundingClientRect();
        if (box.bottom > 0 && box.top < 180) headerHeight = clamp(box.bottom, 0, innerHeight * .3);
      }
      const val = `${Math.round(headerHeight)}px`;
      if (this.style.getPropertyValue('--mlwd-header') !== val) this.style.setProperty('--mlwd-header',val);
      if (!this.enabled) {
        this.render(states.build);
        this.ribbon.style.transform = 'none';
        this.style.setProperty('--mlwd-progress','1');
        this.number.textContent = '01';
        this.status.textContent = 'MAY-LONDON / DIGITAL';
        for (const chapter of this.chapters) chapter.querySelector('.mlwd-chapter-rule').style.transform = 'none';
        return;
      }
      this.ribbon.style.transform = `translateX(${-clamp(-own.top / Math.max(own.height,1)) * 280}px)`;
      const stageBox = this.stage.getBoundingClientRect();
      const anchor = this.small.matches ? Math.min(innerHeight * .82, stageBox.bottom + 130) : headerHeight + (innerHeight - headerHeight) * .5;
      const positions = this.chapters.map(chapter => {
        const box = chapter.getBoundingClientRect();
        return box.top + (this.small.matches ? 115 : box.height * .5);
      });
      let index = 0;
      while (index < positions.length - 1 && positions[index + 1] <= anchor) index++;
      const next = Math.min(index + 1, positions.length - 1);
      const progress = next === index ? 0 : clamp((anchor - positions[index]) / Math.max(positions[next] - positions[index], 1));
      const t = ease(clamp((progress - .2) / .65));
      const from = states[this.chapters[index].dataset.scene] || states.build;
      const to = states[this.chapters[next].dataset.scene] || states.build;
      this.render(from.map((value,i) => mix(value,to[i],t)));
      const active = t >= .5 ? next : index;
      this.number.textContent = String(active + 1).padStart(2,'0');
      this.status.textContent = labels[this.chapters[active].dataset.scene] || labels.build;
      this.style.setProperty('--mlwd-progress', String(clamp((index + progress + 1) / positions.length)));
      this.chapters.forEach((chapter,i) => {
        const amount = 1 - clamp(Math.abs(positions[i] - anchor) / Math.max(innerHeight,1));
        chapter.querySelector('.mlwd-chapter-rule').style.transform = `scaleX(${.5 + amount * 2})`;
      });
    }
    render(s) {
      this.device.style.transform = `translateX(${s[0]}%) rotateX(${s[1]}deg) rotateY(${s[2]}deg) rotateZ(${s[3]}deg) scale(${s[4]})`;
      this.wire.style.opacity = s[5];
      this.layers.forEach((layer,i) => { layer.style.transform = `translate3d(${(i - 1) * s[6] * 12}px,${(i - 1) * s[6] * 20}px,${s[6] * (i + 1) * 12}px)`; });
      this.device.style.opacity = s[11];
      this.capture.style.transform = `translateY(${s[13]}%)`;
      const reveal = (node,value,rotation=0) => {
        node.style.opacity = value;
        node.style.transform = `translateY(${(1 - value) * 65}px) rotate(${rotation * value}deg)`;
      };
      reveal(this.phone,s[7],7); reveal(this.swatch,s[8],-6); reveal(this.code,s[9],-4);
      this.security.style.opacity = s[10];
      this.security.style.transform = `scale(${.8 + .2 * s[10]})`;
      this.security.style.setProperty('--mlwd-shield',String((1 - s[10]) * 340));
      this.tags.forEach((tag,i) => { tag.style.opacity = s[12]; tag.style.transform = `translateY(${s[6] * (i ? 14 : -14)}px) rotate(${i ? 5 : -6}deg)`; });
    }
    disconnectedCallback() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.controller?.abort();
      for (const mq of [this.motion,this.small,this.short]) mq?.removeEventListener('change',this.configureBound);
      this.controller = null;
      this.frame = 0;
    }
  }
  customElements.define('ml-webdev-story',WebdevStory);
})();

  } catch(e) { console.error(e); }
})();
})();
